export const mailTypes = [
  { name: "Standard Dak" },
  { name: "Registered Dak" },
  { name: "Speedpost" },
  { name: "Courier" },
  { name: "Other" },
];
